export function isModalOpen() {
  return (
    document.getElementById("root")?.getAttribute("aria-hidden") === "true" ||
    !!document.querySelector("[aria-modal='true']:not([aria-hidden='true'])")
  );
}
